import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';
import { KundenAuswahlComponent } from './components/kunden-auswahl/kd-auswahl.component';

const routes: Routes = [
    {path: RouteNames.BASE, pathMatch: 'full', redirectTo: RouteNames.FREI},
    {path: RouteNames.SUB_PAGE, component: KundenAuswahlComponent}
];


@NgModule({
    declarations: [
        KundenAuswahlComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class KundenAuswahlModule {
}
